export default __webpack_public_path__ + "static/media/websiteScreen1.afbef037.png";